<template>
  <div class="container">
    <transition name="slide">
      <div v-if="panelOpen" class="panel">
        <h2 class="panel-title">功能列表</h2>
        <div v-for="(func, index) in functions" :key="func.iD" class="function-group">
          <div class="function-header">
            <span class="function-name">{{ index + 1 }}. {{ func.function }}</span>
          </div>
          <form @submit.prevent="submitForm(func.iD, index,1)">
            <div v-for="param in func.paramList" :key="param.iD" v-if="param.show === true" class="input-group">
              <label :for="param.paramName">{{ param.paramDescription }}</label>
              <input :id="param.paramName" v-model="formData[func.iD][param.paramName]" type="text"/>
            </div>
            <button type="submit">执行</button>
          </form>
        </div>
      </div>
    </transition>
    <div v-if="!panelOpen" class="results">
      <div v-if="currentResult.length" class="result-item">
        <h3 v-html="currentFunctionName"></h3>
        <div v-if="currentDataType === 1">
          <table class="styled-table">
            <thead>
            <tr>
              <th v-for="(value, key) in currentResult[0]" :key="key" v-html="key"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in currentResult" :key="index">
              <td v-for="(value, key) in item" :key="key" v-html="isDate(value) ? formatDate(value) : value"></td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else-if="currentDataType === 2">
          <custom-component :messages="currentResult"></custom-component>
        </div>
        <div v-else-if="currentDataType === 3">
          <QzoneMessage></QzoneMessage>
        </div>
        <div v-if="hasPagination" class="pagination">
          <button @click="prevPage" :disabled="isPrevDisabled">上一页</button>
          <span>第 {{ currentPage }} 页</span>
          <button @click="nextPage" :disabled="isNextDisabled">下一页</button>
        </div>
      </div>
    </div>
    <button @click="togglePanel" class="floating-button">
      {{ panelOpen ? '隐藏' : '展开' }}
    </button>
  </div>
</template>

<script>
import axios from 'axios';
import CustomComponent from "@/components/menu/other/qzone/CustomComponent";
import QzoneMessage from "@/components/menu/other/qzone/QzoneMessage";

export default {
  components: {
    CustomComponent, QzoneMessage
  },
  data() {
    return {
      functions: [],
      formData: {},
      panelOpen: true,
      currentResult: [],
      currentFunctionName: '',
      currentPage: 1,
      pageSize: 100,
      hasPagination: false,
      currentFunctionId: null,
      currentFunctionIndex: null,
      currentDataType: null,
      isPrevDisabled: true,
      isNextDisabled: true,
      getFunctionListUrl: '/api/qzone/getFunctionList',
      getDataBySqlUrl: '/api/qzone/getDataBySql',

    };
  },
  created() {
    let loginQQ = localStorage.getItem('loginQQ')
    if (loginQQ === null || loginQQ === 'null' || loginQQ === undefined) {
      this.$router.push('qzone_login')
      return;
    }
    this.fetchData();
  },
  methods: {
    fetchData() {
      let that = this;
      const myQQ = localStorage.getItem('loginQQ');
      axios.get(this.getFunctionListUrl, {
        params: {
          qq: myQQ
        }
      }).then(response => {
        this.functions = response.data.responseData;
        this.functions.forEach(func => {
          this.$set(this.formData, func.iD, {});
          func.paramList.forEach(param => {
            this.$set(this.formData[func.iD], param.paramName, '');
          });
        });
      })
          .catch(error => {
            console.error('获取功能列表失败:', error);
          });
    },
    togglePanel() {
      this.panelOpen = !this.panelOpen;
    },
    submitForm(functionId, index, change) {
      if (change === 1) {
        this.currentPage = 1;
      }
      this.currentFunctionId = functionId;
      this.currentFunctionIndex = index;
      this.currentDataType = this.functions[index].dataType;
      if (this.currentDataType === 3) {
        this.panelOpen = false;
        this.currentResult = [1, 1];
        this.currentFunctionName = null
        return;
      }
      if (this.currentDataType === 4) {
        localStorage.removeItem('loginQQ');
        localStorage.removeItem('loginSigData')
        localStorage.removeItem('QzoneloginSig')
        this.$router.push('qzone_login')
        return;
      }
      const formData = new FormData();
      const params = this.formData[functionId];
      for (const key in params) {
        formData.append(key, params[key]);
      }
      formData.append('sqlID', functionId);

      if ('mYQQ' in params) {
        const myQQ = localStorage.getItem('loginQQ');
        if (myQQ) {
          formData.set('mYQQ', myQQ);
        }
      }

      const hasLimitStart = 'LimitStart' in params;
      const hasLimitStop = 'LimitCount' in params;
      this.hasPagination = hasLimitStart && hasLimitStop;

      if (this.hasPagination) {
        const limitStart = (this.currentPage - 1) * this.pageSize;
        formData.set('LimitStart', limitStart);
        formData.set('LimitCount', this.pageSize);
      }

      this.isPrevDisabled = true;
      this.isNextDisabled = true;

      axios.post(this.getDataBySqlUrl, formData)
          .then(response => {
            this.currentResult = response.data.responseData || [];
            this.currentFunctionName = this.functions[index].function;
            this.panelOpen = false;

            this.isPrevDisabled = this.currentPage === 1;
            this.isNextDisabled = this.currentResult.length < this.pageSize;
          })
          .catch(error => {
            console.error('执行失败:', error);
          });
    },
    nextPage() {
      this.currentPage++;
      this.submitForm(this.currentFunctionId, this.currentFunctionIndex, 0);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.submitForm(this.currentFunctionId, this.currentFunctionIndex, 0);
      }
    },
    isDate(value) {
      const date = new Date(value);
      return !isNaN(date.getTime()) && date.getFullYear() >= 1900 && date.getFullYear() <= new Date().getFullYear() && value.includes('-') && value.includes(':');
    },
    formatDate(value) {
      const date = new Date(value);
      return new Intl.DateTimeFormat('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).format(date).replace(/\//g, '-');
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  overflow-x: hidden;
}

.panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 80%;
  height: 100vh;
  overflow-y: auto;
  border-right: 1px solid #bbb;
  background: linear-gradient(135deg, #f0f8ff, #e6f7ff);
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 5px 15px;
  transform: translateX(0);
}

.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from, .slide-leave-to {
  transform: translateX(-100%);
}

.panel-title {
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333;
}

.function-group {
  margin-bottom: 5px;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: linear-gradient(135deg, #e6f7ff, #ccf2ff);
}

.function-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #cce7ff;
  padding: 5px;
  border-radius: 5px;
  margin-bottom: 5px;
}

.function-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.input-group {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  background-color: #e0f7fa;
  padding: 5px;
  border-radius: 5px;
  box-sizing: border-box;
  width: 100%;
}

label {
  margin-right: 5px;
  font-size: 14px;
  flex: 0 0 30%;
  white-space: nowrap;
  color: #333;
}

input {
  flex: 1;
  padding: 5px;
  box-sizing: border-box;
  width: 0;
  border: 1px solid #bbb;
  border-radius: 3px;
}

.results {
  margin-top: 1px;
}

.result-item {
  margin-bottom: 15px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: linear-gradient(135deg, #f9f9f9, #e0f7fa);
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin: 25px 0;
  font-size: 0.9em;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
}

.styled-table thead tr {
  background-color: #009879;
  color: #ffffff;
  text-align: center;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  border: 1px solid #dddddd;
}

.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}

.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #009879;
}

.styled-table tbody tr:hover {
  background-color: #f1f1f1;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pagination button {
  margin: 0 5px;
  padding: 5px 10px;
  border: none;
  background-color: #007bff;
  color: white;
  border-radius: 3px;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.floating-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #007bff;
  color: white;
  border: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
